import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import axiosInstance from 'utils/axios';

/* eslint-disable no-useless-catch */

// eslint-disable-next-line import/prefer-default-export
export const getAgentProfile = async (memberCode) => {
    try {
        const { data } = await axiosInstance.get(`${ARYABHATTA_API_DOMAIN_V1}members/${memberCode}/agent-profile`);
        return data;
    } catch (error) {
        throw error;
    }
};
